export const projectAlias = {
  legacyProjects: 'legacyProjects',
  ritestream: 'ritestream',
  wizardia: 'wizardia',
  cryptoverse: 'cryptoverse',
  supernova: 'supernova',
  animalconcerts: 'animalconcerts',
  animalconcertsFS: 'animalconcerts-flashpool',
  karmaverse: 'karmaverse',
  ookeenga: 'ookeenga',
  ookeengaINO: 'ookeenga-INO',
  roe: 'realmsofeth',
  kaizen: 'kaizen',
};
